import { getStore } from '../store/store';
import { SearchScopeKind } from 'owa-search-service/lib/data/schema/SearchScope';

/**
 * Determines whether the current search scope is set to recursive search (subfolders).
 * Returns true if the staticSearchScope has isSubfolderScope set to true.
 */
export default function getIsSubfolderScope(): boolean {
    const store = getStore();
    const { staticSearchScope } = store;

    // Check if any scope type has isSubfolderScope set to true
    return (
        (staticSearchScope?.kind === SearchScopeKind.PrimaryMailbox &&
            staticSearchScope.isSubfolderScope === true) ||
        (staticSearchScope?.kind === SearchScopeKind.ArchiveMailbox &&
            staticSearchScope.isSubfolderScope === true) ||
        (staticSearchScope?.kind === SearchScopeKind.SharedFolders &&
            staticSearchScope.isSubfolderScope === true)
    );
}
